var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('schedule-table',{attrs:{"items":_vm.items,"headers":_vm.headers,"type":"family","users":_vm.users}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }